import { render, staticRenderFns } from "./curve.vue?vue&type=template&id=f00c5120&scoped=true&"
import script from "./curve.vue?vue&type=script&lang=js&"
export * from "./curve.vue?vue&type=script&lang=js&"
import style0 from "./curve.vue?vue&type=style&index=0&id=f00c5120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c5120",
  null
  
)

export default component.exports